import {Pipe, PipeTransform} from '@angular/core';
import * as removeAccents from 'remove-accents';

@Pipe({
    name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

    transform(value: any, word: string): any {
        let resultadoPesquisa = [];
        if (!word) {
            return value;
        } else {
            word = removeAccents(word).toLocaleLowerCase();
            resultadoPesquisa = value.filter(s => {
                return removeAccents(s.codigo).toLocaleLowerCase().includes(word) || removeAccents(s.nome).toLocaleLowerCase().includes(word)
                    || removeAccents(s.nomeResponsavel || '').toLocaleLowerCase().includes(word) || removeAccents(s.emailResponsavel || '').toLocaleLowerCase().includes(word);
            });
        }
        return resultadoPesquisa;
    }

}
